module.exports = __webpack_public_path__ + "static/media/road_infinite.c6606fc4.gif";